module.exports = __webpack_public_path__ + "static/media/0afcaf58-2c3f-4fb7-aee8-06ac4486fe52.d725c68d.webp";